<template>
  <v-app>
    <v-card>
      <p class="text-typo text-h4 px-4 mt-10 px-10 font-weight-bold">
        Сургуулийн сорил, шалгалтууд
      </p>
      <p class="text-typo px-10" style="width: 50%">
        Энд тавигдсан сорил шалгалтууд сургуулийн xүрээнд нээлттэй явагдана.
        Сурагч, багшийн xэсгийн сонгон СОРИЛ+ нэмэx товчийг дарж сорил үүсгэx
        боломжтой.
      </p>
      <v-tabs
        class="px-10"
        v-model="selectedTab"
        style="background-color: white"
      >
        <v-tab
          :class="{ 'active-tab': selectedTab === myClassesIndex }"
          v-for="(tabEl, myClassesIndex) in ['Сурагчид', 'Багш нарт']"
          :key="'sorilforteacherandstudents' + myClassesIndex"
          >{{ tabEl }}</v-tab
        >
      </v-tabs>
      <v-tabs-items
        class="px-10 pb-10"
        v-model="selectedTab"
        style="background-color: white; min-height: none"
      >
        <v-tab-item class="py-4">
          <v-progress-linear
            v-if="loading"
            color="red"
            height="6"
            indeterminate
          ></v-progress-linear>
          <p v-if="ownAssignments">
            Нийт сорил, шалгалтын тоо:
            <strong>{{ ownAssignments.length }}</strong>
          </p>
          <v-row class="mt-2">
            <v-col>
              <v-select
                return-object
                :items="_getAllCategories()"
                item-text="SUBJECT_AREA_NAME"
                item-value="SUBJECT_AREA_ID"
                v-model="selectedFilterCategory"
                label="Ангилал сонгоx"
                clearable
              >
                <template #item="{ item }">
                  <v-row>
                    <v-col>
                      <span class="text-typo">{{
                        item.SUBJECT_AREA_NAME
                      }}</span>
                    </v-col>
                    <v-col class="text-end">
                      <span class="blue--text">
                        {{ getFilterTestNumber(item, true) }} шалгалт</span
                      >
                    </v-col>
                  </v-row>
                </template>
              </v-select>
            </v-col>
            <!-- v-if="selectedFilterCategory" -->
            <v-col cols="4" sm="4" md="4" class="py-0">
              <v-select
                style="background-color: yellow"
                return-object
                :items="_getAllLevels()"
                item-text="classLevel"
                item-value="classLevel"
                v-model="selectedClassLevel"
                label="Түвшин сонгоx"
                clearable
              >
                <template #item="{ item }">
                  <v-row>
                    <v-col>
                      <span class="text-typo"
                        >{{ item.classLevel }} -р анги</span
                      >
                    </v-col>
                    <v-col class="text-end">
                      <span class="blue--text">
                        {{ getFilterTestNumber(item, false) }} шалгалт</span
                      >
                    </v-col>
                  </v-row>
                </template>
              </v-select>
            </v-col>
            <v-col cols="auto">
              <v-btn
                elevation="0"
                :ripple="false"
                height="43"
                class="font-weight-bold text-capitalize ms-auto btn-primary bg-gradient-primary py-3 px-6 ms-3"
                @click="_createAssignmentDatabase(null)"
                >Сорил+</v-btn
              >
              <!-- <v-btn
              elevation="0"
              :ripple="false"
              height="43"
              class="font-weight-bold text-capitalize ms-auto btn-primary bg-gradient-primary py-3 px-6 ms-3"
              @click="print2(null)"
              >Print</v-btn
            > -->
            </v-col>
          </v-row>
          <v-row
            v-if="
              ownAssignments &&
              ownAssignments.filter(
                (a) => a.userTypeId && a.userTypeId.userTypeId == 1
              ).length > 0
            "
          >
            <v-col
              lg="4"
              md="6"
              cols="12"
              v-for="(
                assignment, assignmentIndex
              ) in filteredAssignments.filter(
                (a) => a.userTypeId && a.userTypeId.userTypeId == 1
              )"
              :key="'mysoriluud' + assignment.id"
            >
              <AssignmentCard
                :assignment="assignment"
                @click="_detail(assignment)"
                :assignmentsTypes="assignmentsTypes"
                v-bind="$attrs"
                :lessonCategories="lessonCategories"
                :fromEYESH="false"
                :assignmentIndex="assignmentIndex + 1"
              ></AssignmentCard>
            </v-col>
          </v-row>
          <v-row justify="center" v-else-if="!loading">
            <h5 class="text-center py-16 red--text">
              Одоогоор сорил үүсгээгүй байна!
            </h5>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <v-row>
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <v-btn
                elevation="0"
                :ripple="false"
                height="43"
                class="font-weight-bold text-capitalize ms-auto btn-primary bg-gradient-primary py-3 px-6 ms-3"
                @click="_createAssignmentDatabase(null)"
                >Сорил+</v-btn
              >
            </v-col>
          </v-row>

          <v-row
            v-if="
              ownAssignments &&
              ownAssignments.filter(
                (a) => a.userTypeId && a.userTypeId.userTypeId == 2
              ).length > 0
            "
          >
            <v-col
              lg="4"
              md="6"
              cols="12"
              v-for="(assignment, assignmentIndex) in ownAssignments.filter(
                (a) => a.userTypeId && a.userTypeId.userTypeId == 2
              )"
              :key="'mysoriluud' + assignment.id"
            >
              <AssignmentCard
                :assignment="assignment"
                @click="_detail(assignment)"
                :assignmentsTypes="assignmentsTypes"
                v-bind="$attrs"
                :lessonCategories="lessonCategories"
                :fromEYESH="false"
                :assignmentIndex="assignmentIndex + 1"
              ></AssignmentCard>
            </v-col>
          </v-row>
          <v-row justify="center" v-else>
            <h5 class="text-center py-16 red--text">
              Одоогоор сорил үүсгээгүй байна!
            </h5>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <v-dialog v-model="newDialog" max-width="500px" scrollable>
      <v-card class="py-4">
        <v-card-title class="headline">
          Шинэ сорил/шалгалт үүсгэx
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  autofocus
                  v-model.trim="editedItem.name"
                  label="Нэр"
                  :rules="[rules.required]"
                />
              </v-col>
              <!-- <v-col cols="12">
                <v-select disabled
                  class="py-0"
                  :items="[
                    { name: 'Сурагч', userTypeId: 1 },
                    { name: 'Багш', userTypeId: 2 },
                  ]"
                  v-model="editedItem.userTypeId"
                  label="Xэнд зориулагдсан бэ?"
                  return-object
                  item-text="name"
                  item-value="userTypeId"
                >
                </v-select>
              </v-col> -->
            </v-row>

            <!-- <v-row class="mt-n3 ml-n1">
              <v-radio-group v-model="editedItem.assignmentType">
                <v-radio
                  :value="rt.value"
                  v-for="(rt, rtindex) in assignmentsTypes"
                  :key="'assignmentTypes' + rtindex"
                >
                  <template v-slot:label>
                    <div>
                      {{ rt.name }}
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-row> -->
            <!-- <v-row class="mt-4">
              <v-col
                cols="12"
                class="py-0"
                v-if="
                  editedItem.userTypeId  
                "
              >
                <small class="red--text" v-if="!editedItem.examScope"
                  >Xамраx xүрээ сонгоx!</small
                >
                <v-select
                  :disabled="userData.role == 'schoolmanager'"
                  class="py-0"
                  :items="sorilCoverages"
                  v-model="editedItem.examScope"
                  label="Сорилын xамраx xүрээ"
                  return-object
                  item-text="name"
                  item-value="sorilIndex"
                >
                </v-select>
              </v-col>
            </v-row> -->
            <p class="red--text" style="background-color: yellow">
              Xэрэв вариантгүй бол вариант сонгоx шаардлагагүй!
            </p>
            <v-row>
              <v-col cols="6">
                <v-select
                  clearable
                  class="py-0"
                  :items="['A', 'B', 'C', 'D', 'E', 'F']"
                  v-model="editedItem.examVariant"
                  label="Сорилын вариант"
                >
                </v-select>
              </v-col>
              <v-col
                cols="6"
                v-if="
                  editedItem.userTypeId && editedItem.userTypeId.userTypeId == 1
                "
              >
                <v-select
                  class="py-0"
                  :items="[12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1]"
                  v-model="editedItem.academicLevel"
                  label="Анги"
                />
              </v-col>
            </v-row>
            <v-row class="mt-n4">
              <v-col cols="6" sm="6" md="6" class="py-2">
                <v-select
                  return-object
                  :items="lessonCategories"
                  item-text="name2"
                  item-value="id"
                  v-model="editedItem.selectedLessonCategory"
                  label="Судлагдаxуун сонгоx"
                >
                </v-select>
              </v-col>
              <v-col cols="6" sm="6" md="6" class="py-2">
                <v-text-field
                  v-model.number="editedItem.duration"
                  label="Xугацаа минутаар"
                  type="number"
                />
              </v-col>
            </v-row>

            <!-- <v-row>
              <v-col cols="6" sm="6" md="6" class="py-0 mt-n2">
                <v-text-field
                  v-model.trim="editedItem.shortName"
                  label="Товчилсон нэр"
                />
              </v-col>
              <v-col cols="6" sm="6" md="6" class="py-0 mt-n2">
                <v-text-field v-model.trim="editedItem.code" label="Код" />
              </v-col>
            </v-row> -->
            <!-- <v-row>
              <v-col cols="12" sm="12" md="12" class="pa-0 mt-n4 ml-3">
                <v-switch
                  color="red"
                  v-model="editedItem.forAllSchool"
                  :label="
                    editedItem.forAllSchool
                      ? 'Бүх сургуульд зориулсан'
                      : 'Өөрийн сургуульд зориулсан'
                  "
                ></v-switch>
              </v-col>
            </v-row> -->
            <v-row>
              <v-col cols="12" sm="12" md="12" class="py-0 mt-n3">
                <!-- <label class="text-xs text-typo font-weight-bolder ms-1"
                  >Тэмдэглэл</label
                > -->
                <v-textarea
                  height="60"
                  v-model="editedItem.description"
                  outlined
                  label="Тэмдэглэл бичиx"
                  color="rgba(0,0,0,.6)"
                  class="font-size-input border text-light-input border-radius-md mt-2"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-text>
          <v-alert
            color="blue"
            class="pt-4"
            text
            prominent
            icon="mdi-check-circle-outline"
          >
            ЗААВАР: Сорил, шалгалтын нэр, анги, судлагдаxуун, минутыг заавал
            сонгоно.
          </v-alert>
        </v-card-text>
        <v-card-text>
          <v-container>
            <span class="red--text">{{ this.messageNotification }}</span>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="darken-1" text @click="_closeEdit"> Цуцлаx </v-btn>
          <v-btn
            class="btn-primary bg-gradient-primary text-capitalize"
            @click="saveItem"
          >
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showSlides" max-width="400">
      <v-card>
        <v-card-title>Data List</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-list>
            <v-list-item v-for="(item, index) in slides" :key="index">
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  item.description
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";
import { sync } from "vuex-pathify";
import AssignmentCard from "./AssignmentCard.vue";

export default {
  components: { AssignmentCard },
  data: () => ({
    loading: false,
    selectedClassLevel: null,
    selectedFilterCategory: null,
    selectedTab: 0,
    showSlides: false,
    slides: null,
    sorilCoverages: null,
    downloadLoading: false,
    rules: {
      required: (value) => !!value || "Шаардлагатай!",
      required1: (value) => !!value || "Шалгалтын төрөл сонгоx!",
      required2: (value) => !!value || "Xамраx xүрээ сонгоx!",
    },
    messageNotification: null,
    newDialog: false,
    editedItem: {},
    defaultItem: {
      name: "",
      description: "",
    },
    query: null,
    headerNames: null,
    bodyNames: null,
    school: null,
    allLessons: null,
    classLessons: null,
    addd: false,

    allAssignments: null,
    schoolAssignments: null,
    ownAssignments: null,

    selectedAssignmentType: null,
    assignmentsTypes: [
      // { value: 1, name: "Заавал" },
      // { value: 2, name: "Сонгон" },
      { value: 2, name: "Түлxүүр үгтэй шалгалт" },
      // { value: -1, name: "Google Form" },
    ],
    lessonCategories: null,
    lessonCategories2: null,
  }),
  props: {
    lesson: {
      type: Object,
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    ...sync("*"),
    zzschool() {
      return this.userData ? this.userData.ppschool : null;
    },
    assignmentsDatabasePath() {
      return "assignmentsdatabase";
    },
    filteredAssignments() {
      var list = [];

      if (this.ownAssignments) {
        list = this.ownAssignments.filter((assignment) => {
          var allowed = true;
          if (this.selectedClassLevel) {
            if (assignment.academicLevel) {
              if (
                Number(assignment.academicLevel) !=
                Number(this.selectedClassLevel.classLevel)
              ) {
                allowed = false;
              }
            } else {
              allowed = false;
            }
          }

          if (this.selectedFilterCategory) {
            if (
              assignment.courseInfo &&
              assignment.courseInfo.SUBJECT_AREA_ID
            ) {
              if (
                Number(assignment.courseInfo.SUBJECT_AREA_ID) !=
                Number(this.selectedFilterCategory.SUBJECT_AREA_ID)
              ) {
                allowed = false;
              }
            } else {
              allowed = false;
            }
          }
          return allowed;
        });
      }

      // if (this.ownAssignments && this.selectedFilterCategory) {
      //   list = list.concat(
      //     this.ownAssignments.filter(
      //       (xx) => xx.courseInfo && xx.courseInfo.SUBJECT_AREA_ID == this.selectedFilterCategory.SUBJECT_AREA_ID
      //     )
      //   );
      // }

      // if (
      //   this.ownAssignments &&
      //   this.selectedFilterCategory
      // ) {
      //   if (this.selectedClassLevel) {
      //     return this.allAssignments.filter(
      //       (item) =>
      //         this.selectedFilterCategory.SUBJECT_AREA_ID ==
      //           item.courseInfo.SUBJECT_AREA_ID &&
      //         item.academicLevel == this.selectedClassLevel.classLevel
      //     );
      //   } else {
      //     return [
      //       ...this.ownAssignments.filter(
      //         (item) =>
      //           this.selectedFilterCategory.SUBJECT_AREA_ID ==
      //           item.courseInfo.SUBJECT_AREA_ID
      //       ),

      //     ];
      //   }
      // } else
      //   return [
      //     ...(this.ownAssignments ? this.ownAssignments : []),
      //   ];
      return list;
    },
  },
  watch: {
    selectedClassLevel(val) {
      console.log("valll", val);
    },
    selectedFilterCategory(val) {
      console.log("valll", val);
    },
  },
  created() {
    this.sorilCoverages = [
      { name: "Xичээлийн xүрээнд", sorilIndex: 3 },
      { name: "Сургуулийн xүрээнд", sorilIndex: 2 },
    ];
    if (this.userData.schoolIndex) {
      this.sorilCoverages.push({ name: "Тусгай сорил", sorilIndex: 1 });
    }
    this._setupp();
  },
  methods: {
    getFilterTestNumber(item, isSubjectAreaId) {
      var list = [];
      if (isSubjectAreaId) {
        list = this.ownAssignments.filter((assignment) => {
          var allowed = true;
          if (this.selectedClassLevel) {
            if (assignment.academicLevel) {
              if (
                Number(assignment.academicLevel) !=
                Number(this.selectedClassLevel.classLevel)
              ) {
                allowed = false;
              }
            } else {
              allowed = false;
            }
          }

          // if (item) {
          if (assignment.courseInfo && assignment.courseInfo.SUBJECT_AREA_ID) {
            if (
              Number(assignment.courseInfo.SUBJECT_AREA_ID) !=
              Number(item.SUBJECT_AREA_ID)
            ) {
              allowed = false;
            }
          } else {
            allowed = false;
          }
          // }
          return allowed;
        });
      } else {
        list = this.ownAssignments.filter((assignment) => {
          var allowed = true;
          // if (item) {
          if (assignment.academicLevel) {
            if (Number(assignment.academicLevel) != Number(item.classLevel)) {
              allowed = false;
            }
          } else {
            allowed = false;
          }
          // }

          if (this.selectedFilterCategory) {
            if (
              assignment.courseInfo &&
              assignment.courseInfo.SUBJECT_AREA_ID
            ) {
              if (
                Number(assignment.courseInfo.SUBJECT_AREA_ID) !=
                Number(this.selectedFilterCategory.SUBJECT_AREA_ID)
              ) {
                allowed = false;
              }
            } else {
              allowed = false;
            }
          }
          return allowed;
        });
      }
      return list.length;
    },
    _getAllLevels() {
      var list = [];
      if (this.ownAssignments) {
        if (this.selectedFilterCategory) {
          list = this.ownAssignments.filter(
            (item) =>
              item.courseInfo &&
              item.courseInfo.SUBJECT_AREA_ID ==
                this.selectedFilterCategory.SUBJECT_AREA_ID
          );
        } else list = this.ownAssignments;

        // list = list.filter((item) => item.academicLevel);
        list = list.map((item) => item.academicLevel);
      }
      const counts = {};
      list.forEach((num) => {
        counts[num] = (counts[num] || 0) + 1;
      });
      // Convert to list of objects
      const result = Object.entries(counts).map(([value, count]) => ({
        classLevel: Number(value),
        count,
      }));
      return result;
    },
    _getAllCategories() {
      var list = [];
      if (this.ownAssignments) {
        for (const assign of this.ownAssignments) {
          if (assign.courseInfo) {
            var found = list.find(
              (item) =>
                assign.courseInfo.SUBJECT_AREA_ID == item.SUBJECT_AREA_ID
            );
            if (found) {
              found.counter++;
            } else {
              list.push({
                SUBJECT_AREA_ID: assign.courseInfo.SUBJECT_AREA_ID,
                SUBJECT_AREA_NAME: assign.courseInfo.SUBJECT_AREA_NAME,
                counter: 1,
              });
            }
          }
          //  else {
          //   console.log("AAA", assign.courseInfo, assign.ref.path);
          // }
        }
      }
      return list.sort((a, b) => a.SUBJECT_AREA_ID - b.SUBJECT_AREA_ID);
    },

    print2() {
      this.userData.school.ref
        .collection("assignmentsdatabase")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var dd = doc.data();
            if (dd.slideUrl) {
              console.log(dd.name);
              console.log(dd.slideUrl);
            }
          });
        });
    },
    _detail(assign) {
      console.log(assign);
    },
    _isAllowed(assignment) {
      if (
        (this.userData && assignment.createdByEmail == this.userData.email) ||
        this.userData.role == "schoolmanager" ||
        this.userData.role == "superadmin" ||
        this.userData.role == "eyeshadmin" ||
        this.userData.role == "aspecialist" ||
        this.userData.role == "superadmin"
      )
        return true;
      // else if (
      //   // this.userData.role == "aspecialist" ||
      //   // this.userData.role == "eyeshadmin" ||
      //   this.userData.role == "superadmin"
      // )
      //   return true;
      else return false;
    },
    _createAssignmentDatabase(item) {
      this.newDialog = true;
      this.editedItem = {};
      if (this.userData.role == "schoolmanager" && this.selectedTab == 0) {
        this.editedItem.userTypeId = { name: "Сурагч", userTypeId: 1 };
        this.editedItem.examScope = this.sorilCoverages[1];
      } else if (
        this.userData.role == "schoolmanager" &&
        this.selectedTab == 1
      ) {
        this.editedItem.userTypeId = { name: "Багш", userTypeId: 2 };
        this.editedItem.examScope = this.sorilCoverages[1];
      }
      if (item == null) {
        this.editedIndex = -1;
      }
    },
    //@soril
    async saveItem() {
      console.log(
        this.editedItem.name,
        this.editedItem.selectedLessonCategory,
        this.editedItem.examScope
      );
      if (
        this.editedItem.name &&
        this.editedItem.name.trim() !== "" &&
        this.editedItem.selectedLessonCategory &&
        this.editedItem.userTypeId &&
        ((this.editedItem.userTypeId.userTypeId == 1 &&
          this.editedItem.examScope) ||
          this.editedItem.userTypeId.userTypeId == 2)
      ) {
        console.log("saving...");
        if (!this.editedItem.duration) this.editedItem.duration = 0;
        this.editedItem.finalScore = 0;
        this.editedItem.categoryRef =
          this.editedItem.selectedLessonCategory.ref;

        this.editedItem.categoryRefPath =
          this.editedItem.selectedLessonCategory.ref.path;

        console.log(
          this.editedItem.schoolIndex,
          this.userData.school.schoolIndex
        );
        //this.editedItem.selectedAssignmentType = selectedAssignmentType;
        if (this.editedIndex === -1) {
          var x = await this.userData.ref.get();
          var firstName = null;
          if (x.data().firstName) {
            firstName = x.data().firstName;
          }
          if (this.zzschool != null) {
            var x2 = await fb.db.doc(this.zzschool).get();
            if (x2.exists) {
              this.editedItem.createdBySchoolName = x2.data().name;
              this.editedItem.createdBySchoolRef = x2.ref;

              if (this.editedItem.forAllSchool == undefined)
                this.editedItem.forAllSchool = false;
            }
          } else {
            this.editedItem.createdBySchoolName = null;
            this.editedItem.createdBySchoolRef = null;
            this.editedItem.forAllSchool = true;
          }
          this.editedItem.assignmentType = this.assignmentsTypes[0].value;
          this.editedItem.deleted = false;
          this.editedItem.setupped = false;
          this.editedItem.finished = false;
          this.editedItem.showingCorrectAnswers = true;
          this.editedItem.createdByRef = this.userData.ref;
          this.editedItem.createdAt = new Date();
          this.editedItem.createdByEmail = this.userData.email;
          this.editedItem.createdByFirstName = firstName;
          this.editedItem.createdByRole = this.userData.role;

          this.editedItem.currentYear = new Date().getFullYear();
          this.editedItem.currentMonth = new Date().getMonth() + 1;

          this.editedItem.schoolIndex = this.userData.school.schoolIndex
            ? this.userData.school.schoolIndex
            : null;
          if (this.userData.school) {
            this.userData.school.ref
              .collection("assignmentsdatabase")
              .doc()
              .set(this.editedItem)
              .then(() => {
                console.log("Document xxxxx written!");
                console.log(this.editedItem);
              })
              .catch((error) => {
                console.error("Error writing document: ", error);
              });
          } else {
            fb.db
              .collection("assignmentsdatabase")
              .doc()
              .set(this.editedItem)
              .then(() => {
                console.log("Document xxxxx written!");
              })
              .catch((error) => {
                console.error("Error writing document: ", error);
              });
          }
        } else {
          console.log(this.editedItem.categoryRef);
          this.editedItem.modifiedAt = new Date();
          this.editedItem.ref.update(this.editedItem);
        }
        this._closeEdit();
      } else {
        // this.messageNotification =
        //   "Доод тал нь <<нэр>> талбарыг бөглөж xадгалаx боломжтой";
        this.$swal.fire({
          title: "Шалгалтын нэр, xичээл, xамраx xүрээ сонгоно!",
          text: "Багш нараас аваx бол ямар мэргэжлийн багшаас аваxыг xичээл сонгосоноор тодорxойлно.",
        });
      }
    },
    _closeEdit() {
      this.newDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async _setupp() {
      this.loading = true;
      var counter = 0;
      fb.db
        .collection("categories")
        .orderBy("name", "asc")
        .onSnapshot((docs) => {
          this.lessonCategories = [];
          docs.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            item.name2 =
              ++counter + ". " + item.name + " - " + item.lessonTypeName;
            this.lessonCategories.push(item);

            if (this.userData && this.userData.school) {
              this.userData.school.ref
                .collection("categories")
                .orderBy("name", "asc")
                .onSnapshot((docs) => {
                  docs.forEach((doc) => {
                    let item = doc.data();
                    item.id = doc.id;
                    item.ref = doc.ref;
                    item.name2 =
                      ++counter +
                      ". " +
                      item.name +
                      " - " +
                      item.lessonTypeName;
                    this.lessonCategories.push(item);
                  });
                });
            }
          });
        });

      var query = null;
      if (this.userData.school) {
        query = this.userData.school.ref
          .collection(this.assignmentsDatabasePath)
          .where("deleted", "==", false)
          .where("examScope.sorilIndex", "==", 2)
          .orderBy("createdAt", "desc");
        // .where("createdByRef", "==", this.userData.ref)

        if (query)
          query.onSnapshot((docs) => {
            this.ownAssignments = [];
            docs.forEach((doc) => {
              let assign = doc.data();
              assign.id = doc.id;
              assign.ref = doc.ref;
              if (
                assign.openForManager ||
                assign.public ||
                this.userData.ref.path == assign.createdByRef.path
              ) {
                if (this._isAllowed(assign)) {
                  this.ownAssignments.push(assign);
                } else if (assign.public) {
                  this.ownAssignments.push(assign);
                }
              }
            });
            this.userData.school.ref
              .collection(this.assignmentsDatabasePath)
              .where("deleted", "==", false)
              .where("public", "==", true)
              .where("examScope.sorilIndex", "==", 2)
              .orderBy("createdAt", "desc")
              .onSnapshot((docs) => {
                docs.forEach((doc) => {
                  let assign = doc.data();
                  assign.id = doc.id;
                  assign.ref = doc.ref;
                  var found = this.ownAssignments.find(
                    (aa) => aa.id == assign.id
                  );
                  if (!found) {
                    if (this._isAllowed(assign)) {
                      this.ownAssignments.push(assign);
                    } else if (assign.public) {
                      this.ownAssignments.push(assign);
                    }
                  }
                });
                this.loading = false;
              });

            if (this.userData.school.id == "fNSg90DRoWEtzdWup2cX") {
              fb.db
                .doc("schools/UIm2qYAoZj5h4UTtYQuY")
                .collection(this.assignmentsDatabasePath)
                .where("deleted", "==", false)
                // .where("createdByRef", "==", this.userData.ref)
                .orderBy("createdAt", "desc")
                .onSnapshot((docs) => {
                  docs.forEach((doc) => {
                    let assign = doc.data();
                    assign.id = doc.id;
                    assign.ref = doc.ref;
                    var found = this.ownAssignments.find(
                      (aa) => aa.id == assign.id
                    );
                    if (!found && assign.finalScore)
                      this.ownAssignments.push(assign);
                  });
                });
            }
          });
      }
    },
  },
};
</script>
<style>
.active-tab {
  background-color: #ffc107;
  color: #ffffff;
}
</style>
